import { Metamodel } from '../../base/model';
import { AmazonS3Location } from './amazon-s3.location';
import { SapDatasphereForAmazons3LinkedService } from '../../linkedservice/sap-datasphere-for-amazons3.linkedservice';

@Metamodel.model({
    name: 'SapDatasphereForAmazonS3Location',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SapDatasphereForAmazons3LinkedService)
    }
})
export class SapDatasphereForAmazonS3Location extends AmazonS3Location {}
